<template>
  <div class="container">
    <h1>Wanna know more about me ?</h1>
    <h2>I know you do</h2>
    <EmailComponent></EmailComponent>
  </div>
</template>

<script>
import EmailComponent from "@/components/EmailComponent";
export default {
  name: "ContactComponent",
  components: {EmailComponent}
}
</script>

<style scoped>
h1{
  color: darkgoldenrod;
}
h2{
  color: wheat;
}
</style>